import { render } from "./PortfolioWebsitePackage.vue?vue&type=template&id=1acb9ed2&scoped=true"
import script from "./PortfolioWebsitePackage.vue?vue&type=script&lang=js"
export * from "./PortfolioWebsitePackage.vue?vue&type=script&lang=js"

import "./PortfolioWebsitePackage.vue?vue&type=style&index=0&id=1acb9ed2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acb9ed2"]])

export default __exports__